import { useApi } from '@gravitate-js/the-armory'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { getAPIURL } from '@utils/api'
import { getCurrentMarket } from '@utils/general'

export const useEvents = () => {
  const api = useApi({ baseURLOverride: getAPIURL() })
  const queryClient = useQueryClient()

  const eventsQuery = (filters) =>
    useQuery({
      queryKey: ['eventsOverviewQuery', filters],
      queryFn: () => api.post('event/overview', { ...filters, market: getCurrentMarket() }),
      refetchOnWindowFocus: false,
    })

  const createEventMutation = () =>
    useMutation({
      mutationFn: (event) => api.post('event/create', event),
      onMutate: async (newEvent) => {
        await queryClient.invalidateQueries({
          queryKey: ['eventsOverviewQuery'],
        })
      },
    })

  const metadataQuery = useQuery({
    queryKey: ['eventsMetadata'],
    queryFn: () => {
      return api.post('event/metadata', { market: getCurrentMarket() })
    },
    refetchOnWindowFocus: false,
  })

  const affectedMetadataQuery = (eventId) =>
    useQuery({
      queryKey: ['affectedMetadata', eventId],
      queryFn: () => {
        return api.post('event/affected_metadata', {
          event_id: eventId,
          market: getCurrentMarket(),
        })
      },
      enabled: !!eventId,
      refetchOnWindowFocus: false,
    })

  return { eventsQuery, createEventMutation, metadataQuery, affectedMetadataQuery }
}
